import { render } from "./LoadingSmall.vue?vue&type=template&id=5ffdd3e8"
import script from "./LoadingSmall.vue?vue&type=script&lang=js"
export * from "./LoadingSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__